(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["fit-picker"] && !Shopify.designMode) return;
  try {
    class FitPicker extends HTMLElement {
    connectedCallback() {
      if (this._initialised) return;
      this._initialised = true;
      this.init();
    }

    async init() {
      const data = this.dataset;
      const token = data.token;
      const siblingTag = data.siblingTag;
      const domain = data.shopDomain;
      const version = data.apiVersion || '2026-01';

      if (!token || !siblingTag || !domain) return;

      const query =
        'query($q: String!) {' +
        '  products(first: 10, query: $q) {' +
        '    nodes { title handle availableForSale tags }' +
        '  }' +
        '}';
      const variables = { q: "tag:'" + siblingTag.replace(/'/g, "\\'") + "'" };

      // Cache the sibling lookup per session: most PDPs have no sibling fit
      // (cached as an empty list, so no re-query), and toggling back and
      // forth between the two fits reuses the cached result.
      const cacheKey = 'fitpicker:' + version + ':' + siblingTag;
      let nodes = null;
      try {
        const cached = sessionStorage.getItem(cacheKey);
        if (cached !== null) nodes = JSON.parse(cached);
      } catch (error) {
        nodes = null;
      }

      if (nodes === null) {
        try {
          const response = await fetch('https://' + domain + '/api/' + version + '/graphql.json', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': token
            },
            body: JSON.stringify({ query: query, variables: variables })
          });
          if (!response.ok) return;
          const json = await response.json();
          nodes = (json && json.data && json.data.products && json.data.products.nodes) || [];
          try { sessionStorage.setItem(cacheKey, JSON.stringify(nodes)); } catch (error) {}
        } catch (error) {
          return;
        }
      }

      if (!nodes.length) return;

      const colour = (data.currentColour || '').toLowerCase();
      let target = null;
      if (colour) {
        target = nodes.find(function (node) {
          return (node.tags || []).some(function (tag) {
            return tag.toLowerCase() === 'x-colourcode:' + colour;
          });
        });
      }
      if (!target) {
        target = nodes.find(function (node) { return node.availableForSale; }) || nodes[0];
      }

      const siblingUrl = '/products/' + target.handle;
      const currentIsWide = data.currentIsWide === 'true';
      const labelRegular = data.labelRegular || 'Regular';
      const labelWide = data.labelWide || 'Wide';
      const currentLabel = currentIsWide ? labelWide : labelRegular;
      const siblingLabel = currentIsWide ? labelRegular : labelWide;

      const currentButton = document.createElement('span');
      currentButton.className = 'fit-picker__option fit-picker__option--current';
      currentButton.setAttribute('aria-current', 'true');
      currentButton.textContent = currentLabel;

      const siblingButton = document.createElement('a');
      siblingButton.className = 'fit-picker__option';
      siblingButton.href = siblingUrl;
      siblingButton.textContent = siblingLabel;

      const options = this.querySelector('[data-fit-options]');
      if (!options) return;
      options.innerHTML = '';
      if (currentIsWide) {
        options.appendChild(siblingButton);
        options.appendChild(currentButton);
      } else {
        options.appendChild(currentButton);
        options.appendChild(siblingButton);
      }

      const currentLabelEl = this.querySelector('[data-fit-current-label]');
      if (currentLabelEl) currentLabelEl.textContent = currentLabel;

      this.hidden = false;
    }
  }

  if (!customElements.get('fit-picker')) {
    customElements.define('fit-picker', FitPicker);
  }
  } catch(e) { console.error(e); }
})();

})();
